import { render, staticRenderFns } from "./RbuEditionList.vue?vue&type=template&id=0ccd448b"
import script from "./RbuEditionList.vue?vue&type=script&lang=js"
export * from "./RbuEditionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports